import { i18nKeys, literals } from './i18nkeys';

const translation: literals = {
  [i18nKeys.Pano]: 'Pano',
  [i18nKeys.Scan]: 'Scan',
  [i18nKeys.FlightScheduledDateTitle]: 'Scheduled date',
  [i18nKeys.FlightExifDateTitle]: 'Date from EXIF',

  [i18nKeys.UploadsListActivity]: (daysBack: string) => `Your activity over the past ${daysBack} days`,
  [i18nKeys.UploadsListActivityError]: 'Failed to load uploads list',
  [i18nKeys.UploadsListActivityErrorDetails]: 'Please contact Operations team',
  [i18nKeys.UploadsListNoUploads]: 'There were no uploads',

  [i18nKeys.FlightDateConfirmationDatePickerDatePlaceholder]: 'Choose date',
  [i18nKeys.FlightDateConfirmationDatePickerExistingScheduleErrorMessage]:
    'You cannot upload photos per another scheduled flight',

  [i18nKeys.InvoicingSubmitInvoice]: 'Submit Invoice',
  [i18nKeys.InvoicingDescription]: 'Add your most recent invoice for the past two weeks of work.',
  [i18nKeys.InvoicingSelectDateButtonDescription]: 'Select date',
  [i18nKeys.InvoicingScanCostsPlaceholder]: 'Total $ for Flights',
  [i18nKeys.InvoicingScanCostsTitle]: 'Total $ for Flights',
  [i18nKeys.InvoicingPanoCostsPlaceholder]: 'Total $ for Panoramas',
  [i18nKeys.InvoicingPanoCostsTitle]: 'Total $ for Panoramas',
  [i18nKeys.InvoicingOtherCostsPlaceholder]: 'Total $ for GCPs and other',
  [i18nKeys.InvoicingOtherCostsTitle]: 'Total $ for GCPs and other',
  [i18nKeys.InvoicingTotalCostsTitle]: 'Overall total',
  [i18nKeys.InvoicingPaymentLinkPlaceholder]: 'Payment link',
  [i18nKeys.InvoicingPaymentLinkTitle]: 'Payment link',
  [i18nKeys.InvoicingPaymentLinkErrorMessage]:
    'Make sure the link is correct. Leave the field blank if you want a direct deposit.',
  [i18nKeys.InvoicingSubmitButtonTitle]: 'Submit',
  [i18nKeys.InvoicingSubmitAnywayButtonTitle]: 'Submit anyway',
  [i18nKeys.InvoicingSentButtonTitle]: 'Invoice sent for review',
  [i18nKeys.InvoicingSendAnotherTitle]: 'Send another invoice',
  [i18nKeys.InvoicingPdfFileInputTitle]: 'Invoice PDF document',
  [i18nKeys.InvoicingPdfFileButtonTitle]: 'Attach PDF invoice',
  [i18nKeys.InvoicingPdfFileButtonPendingTitle]: 'Uploading...',
  [i18nKeys.InvoicingUploadErrorHeader]: 'Looks like something went wrong. Invoice wasn’t sent. Please try again.',
  [i18nKeys.InvoicingNoCostsErrorDescription]: 'Enter total amount for your missions',
  [i18nKeys.InvoicingNoLinkErrorHeader]: 'Please provide invoice PDF document.',
  [i18nKeys.InvoicingDatePickerStartDatePlaceholder]: 'Start date',
  [i18nKeys.InvoicingDatePickerEndDatePlaceholder]: 'End date',
  [i18nKeys.InvoicingStartDateErrorDescription]: 'Select date of First Flight',
  [i18nKeys.InvoicingEndDateErrorDescription]: 'Select date of Last Flight',
  [i18nKeys.InvoicingExpectedCostsFetchErrorHeader]: 'We were unable to check your total for Flights and 360 Panos.',
  [i18nKeys.InvoicingCostsNotMatchErrorHeader]:
    'Your total for Flights and 360 Panos doesn’t match Billable Uploads Amount.',
  [i18nKeys.InvoicingBillableUploadsTitle]: 'Billable uploads',
  [i18nKeys.InvoicingBillableUploadsTotalAmount]: 'Total amount',
  [i18nKeys.InvoicingBillableUploadsListFirstColTitle]: 'Date, Project',
  [i18nKeys.InvoicingBillableUploadsListSecondColTitle]: 'Amount',
  [i18nKeys.InvoicingBillableUploadsSelectDatesErrorMessage]:
    'Please select Start and End Dates for showing billable uploads.',
  [i18nKeys.InvoicingBillableUploadsNoUploadErrorMessage]: 'We didn’t find any billable uploads for this period.',
  [i18nKeys.InvoicingBillableUploadsLoaderTitle]: 'Loading billable uploads',
  [i18nKeys.InvoicingBillableUploadsProcessingInfoMessage]:
    'Please wait for 48 hours before sending the invoices for the scans in the processing stage.',
  [i18nKeys.InvoicingBillableUploadsProcessingStatus]: 'Processing',
  [i18nKeys.InvoicingBillableUploadsFetchErrorMessage]:
    'Billable uploads wasn’t loaded. Something went wrong. Please try again.',
};

export default translation;
